/** Empty-list placeholder — borrowed from the v5 prototype (line 6415-6418).
 *  Uses the ``.empty-state`` block in ``base.css`` for layout + the
 *  ``.crosshair-big`` glyph for visual texture. */
export function EmptyState({ children = 'пусто в этой категории' }: { children?: React.ReactNode }) {
  return (
    <div className="empty-state">
      <div className="crosshair-big" />
      {children}
    </div>
  );
}
